import api from "./apiService";

const UsuarioService = {
  getDadosDashboard: async () => {
    let res = await api.get("relatorio/dashboard");
    return res.data;
  },
  getDadosDashbordResumido: async (dataInicio, dataFim) => {
    let res = await api.get(
      `relatorio/dashboard?dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    return res.data;
  },
  getRelatoriosDashboard: async () => {
    let res = await api.get("relatorio?limite=5");
    return res.data;
  },
  getRelatorioVisualizacao: async (id) => {
    let res = await api.get(`relatorio/${id}`);
    return res.data;
  },
  getRelatorioVisualizacaoToken: async (token) => {
    let res = await api.get(`relatorio/token/${token}`);
    return res.data;
  },
  getRelatorios: async (
    pagina = 1,
    limite = 10,
    documento = undefined,
    data_inicio = undefined,
    data_fim = undefined,
    status = undefined,
    modelo = undefined,
    usuario = undefined
  ) => {
    const params = [];

    if (pagina && pagina != "") {
      params.push(`pagina=${pagina}`);
    }

    if (limite && limite != "") {
      params.push(`limite=${limite}`);
    }

    if (documento && documento != "") {
      params.push(`documento=${documento}`);
    }

    if (data_inicio && data_inicio != "") {
      params.push(`data_inicio=${data_inicio}`);
    }

    if (data_fim && data_fim != "") {
      params.push(`data_fim=${data_fim}`);
    }

    if (status && status != "") {
      params.push(`status=${status}`);
    }

    if (modelo && modelo != "") {
      params.push(`id_modelo=${modelo}`);
    }

    if (usuario && usuario != "") {
      params.push(`id_usuario=${usuario}`);
    }

    const search = params.length > 0 ? `?${params.join("&")}` : "";

    const res = await api.get(`relatorio${search}`);

    return {
      relatorios: res.data,
      total: res.headers["x-total-count"],
    };
  },
};

export default UsuarioService;
